export function constructSnippet(nudge: number) {
  if (nudge === 0) {
    return `\
.element {
  position: fixed;
  inset: 0px;
  width: 16rem;
  height: 6rem;
  margin: auto;
}`;
  }
  return `\
.element {
  position: fixed;
  inset: 0px;
  bottom: ${nudge}px;
  width: 16rem;
  height: 6rem;
  margin: auto;
}`;
}
